module.exports = __webpack_public_path__ + "static/DSC05422-d3267c44418f3cc06389b7e2fa4def74.jpg";